import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, RevenueCategory, RevenueCategoryWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateRevenueCategory(): UseMutationResult<
  AxiosResponse<RevenueCategory>,
  AxiosError<ErrorMessage>,
  RevenueCategoryWrite
> {
  const queryClient = useQueryClient();

  const createRevenueCategory = useCallback(
    (category: RevenueCategoryWrite): Promise<AxiosResponse<RevenueCategory>> => {
      return client.post('revenue-categories/', category);
    },
    [],
  );

  return useMutation(createRevenueCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries(['revenue-categories-autocomplete']);
      queryClient.invalidateQueries(['revenueCategories']);
    },
  });
}
